var map = {
	"./loading/index.tsx": [
		3
	],
	"./media/index.tsx": [
		24,
		3
	],
	"./news/index.tsx": [
		25,
		4
	],
	"./signin/index.tsx": [
		26,
		5
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 22;
module.exports = webpackAsyncContext;